import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function AuthorSection() {
  const revealRef = useScrollReveal();
  return <section className="bg-brand-dark py-10 px-[5%]" data-id="element-14">
      <div ref={revealRef} className="max-w-[700px] mx-auto reveal" data-id="element-15">
        {/* Bio */}
        <div data-id="element-16">
          <div className="font-body text-[11px] tracking-[0.15em] text-brand-gold uppercase mb-4" data-id="element-17">
            LA CREADORA DEL PROTOCOLO
          </div>
          <h2 className="font-display italic text-[44px] text-brand-cream mb-5" data-id="element-18">
            Yajaira Mejías
          </h2>

          <p className="font-body font-light text-[15px] leading-[1.85] text-brand-cream/70 mb-4" data-id="element-19">
            "RENACER no nació de una teoría académica. Nació de la noche más
            oscura — las 3 de la mañana frente a un espejo, mirando a alguien
            que ya no reconocía. La carrera era exitosa, pero el interior estaba
            vacío."
          </p>
          <p className="font-body font-light text-[15px] leading-[1.85] text-brand-cream/70 mb-6" data-id="element-20">
            "De esa desesperación convertida en claridad atómica emergió este
            protocolo. Lo que encontré en ese proceso de muerte y renacimiento
            es lo que hoy entrego en estas páginas — sin filtros, sin teoría
            vacía, desde la experiencia real."
          </p>

          <div className="flex flex-wrap gap-[10px] mt-6" data-id="element-21">
            {['Experiencia vivida', 'Sin filtros', 'Con amor profundo', 'A tu ritmo'].map((pill, i) => <div key={i} className="font-body text-[13px] text-brand-cream/70 border border-brand-gold/30 rounded-[40px] py-[8px] px-[18px] bg-brand-gold/5" data-id="element-22">
                {pill}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}